import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-wait',
  templateUrl: './page-wait.component.html',
  styleUrls: ['./page-wait.component.scss']
})
export class PageWaitComponent implements OnInit {
  public opacityChange = 0;
  loaderLogo = "/assets/images/logo-mini-md.png"
  public splashTransition: string;
  // First access the splash is visible
  public showSplash = false;
  public splashdisplay = "none";

  ngOnInit() {
    this.splashTransition = `opacity 1s`;
    this.opacityChange = 1;
    this.showSplash = true;
    this.splashdisplay = "flex"
  }

}
